import importExport from '../../../assets/icons/importExport.svg'
import { BDropdown } from '../BDropdown/BDropdown'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { showModal } from '../../../store/actions/modalActions'
import { ModalTypes } from '../../../types/modals'
import { faFileUpload } from '@fortawesome/free-solid-svg-icons/faFileUpload'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons/faFileDownload'

interface UploadDownloadConfigProps {
    className?: string
    guid: string
}

export const UploadDownloadConfig = (props: UploadDownloadConfigProps) => {
    const { guid, className } = props
    const dispatch = useAppDispatch()

    const handleUpload = () => {
        dispatch(
            showModal(ModalTypes.UPLOAD_CONFIGS_MODAL, {
                guid,
            })
        )
    }
    const handleDownload = () => {
        dispatch(
            showModal(ModalTypes.CONFIGS_MODAL, {
                guid,
            })
        )
    }

    const uploadConfig = {
        name: 'buttons.uploadConfig',
        icon: faFileUpload,
        action: handleUpload,
    }
    const downloadConfig = {
        name: 'buttons.downloadConfig',
        icon: faFileDownload,
        action: handleDownload,
    }

    const uploadDownloadConfigItems = [uploadConfig, downloadConfig]

    return (
        <BDropdown
            className={`rounded-blue-btn ${className}`}
            tooltip="Upload / Download config"
            dropdownItems={uploadDownloadConfigItems}
            dropdownToggle={
                <img
                    alt=""
                    className="pb-1"
                    src={importExport}
                />
            }
        />
    )
}
